/* 处理打印 */
const isDev = process.env.NODE_ENV === 'development'
const log = console.log.bind(console)
window.log  = console.log  = function () {/*  */ }
if (isDev) {
  window.log  = console.log  = log
}

window.onerror = function (msg, url, lineNo, columnNo, error) {
  console.log('error', msg, url, lineNo, columnNo, error)
}
